function esc(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function publicConsultaUrl(path, param, value) {
  const url = new URL(path, window.location.origin);
  if (value) url.searchParams.set(param, String(value));
  return url.toString();
}

export function printPublicReceipt({
  brand = 'useAmbiental',
  orgName = 'Licenças Ambientais',
  title,
  protocol,
  fields = [],
  note,
  logoUrl,
  bannerUrl,
  coatOfArmsUrl,
}) {
  const rows = fields
    .filter(([, value]) => value != null && value !== '')
    .map(
      ([label, value]) =>
        `<tr><th>${esc(label)}</th><td>${esc(value)}</td></tr>`
    )
    .join('');
  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8" />
  <title>${esc(title)} · ${esc(protocol)}</title>
  <style>
    :root { color-scheme: light; }
    body { font-family: Inter, system-ui, sans-serif; margin: 0; color: #0f172a; background: #fff; }
    .sheet { max-width: 640px; margin: 32px auto; padding: 32px; border: 1px solid #e2e8f0; }
    .banner { margin: -32px -32px 20px; background: #ffffff; display: flex; justify-content: center; }
    .banner img { max-height: 64px; max-width: 100%; object-fit: contain; }
    .brand { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
    .mark { width: 40px; height: 40px; border-radius: 12px; background: #e8f5e9; color: #2E7D32; display: grid; place-items: center; font-weight: 700; }
    .mark img, .wordmark { object-fit: contain; }
    .mark img { width: 40px; height: 40px; border-radius: 12px; }
    .wordmark { height: 32px; max-width: 160px; margin-left: auto; }
    .eyebrow { font-size: 11px; letter-spacing: .18em; text-transform: uppercase; color: #2E7D32; font-weight: 700; margin: 0; }
    h1 { font-size: 20px; margin: 4px 0 0; }
    .proto { font-family: ui-monospace, monospace; font-size: 22px; letter-spacing: .04em; margin: 16px 0 24px; }
    table { width: 100%; border-collapse: collapse; }
    th { text-align: left; color: #64748b; font-size: 12px; font-weight: 600; padding: 8px 0; width: 42%; }
    td { padding: 8px 0; font-weight: 600; }
    .note { margin-top: 24px; font-size: 13px; color: #334155; line-height: 1.5; }
    .foot { margin-top: 28px; font-size: 11px; color: #94a3b8; }
  </style>
</head>
<body>
  <div class="sheet">
    ${bannerUrl ? `<div class="banner"><img src="${esc(bannerUrl)}" alt="" /></div>` : ''}
    <div class="brand">
      <div class="mark">${coatOfArmsUrl || logoUrl ? `<img src="${esc(coatOfArmsUrl || logoUrl)}" alt="" />` : 'A'}</div>
      <div>
        <p class="eyebrow">${esc(brand)}</p>
        <h1>${esc(orgName)}</h1>
      </div>
      ${logoUrl && coatOfArmsUrl ? `<img class="wordmark" src="${esc(logoUrl)}" alt="" />` : ''}
    </div>
    <p class="eyebrow">${esc(title)}</p>
    <p class="proto">${esc(protocol)}</p>
    <table>${rows}</table>
    ${note ? `<p class="note">${esc(note)}</p>` : ''}
    <p class="foot">Comprovante gerado no canal oficial do órgão. Não substitui certidão nem consulta a SEI, DOU ou IBAMA.</p>
  </div>
</body>
</html>`;
  const popup = window.open('', '_blank', 'noopener,noreferrer,width=720,height=900');
  if (!popup) return false;
  popup.document.write(html);
  popup.document.close();
  popup.focus();
  popup.print();
  return true;
}
